module.exports = __webpack_public_path__ + "img/362.26c2fa00.png";